import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MapPin, Globe, Leaf, ArrowLeft } from 'lucide-react';
import { api, fileUrl } from '@/lib/api';

export default function PartnerFarmDetail() {
  const { farmId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/partner-farms/${farmId}`).then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [farmId]);

  if (loading) return <div className="pt-20 min-h-screen bg-cream flex justify-center items-center"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-forest" /></div>;
  if (!data) return <div className="pt-32 min-h-screen bg-cream text-center"><p className="font-manrope text-dark/60">Farm not found.</p></div>;

  const p = data.profile;
  return (
    <div className="pt-20 min-h-screen bg-cream" data-testid="partner-farm-detail">
      <div className="h-64 md:h-80 bg-forest/10 overflow-hidden relative">
        <img src={fileUrl(p.cover_file_id) || 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=1400'} alt={data.name} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-dark/60 to-transparent" />
      </div>
      <div className="container-custom -mt-20 relative pb-20">
        <Link to="/partner-farms" className="inline-flex items-center gap-2 text-cream font-manrope mb-4"><ArrowLeft className="w-4 h-4" />All Partners</Link>
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-brown/10 shadow-hover">
          <h1 className="font-playfair text-4xl font-bold text-dark">{data.name}</h1>
          <div className="flex flex-wrap gap-5 mt-3 text-dark/60 font-manrope">
            {p.town && <span className="flex items-center gap-1.5"><MapPin className="w-4 h-4 text-gold" />{p.town}, NH</span>}
            {p.website && <a href={p.website} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 hover:text-forest"><Globe className="w-4 h-4 text-gold" />Website</a>}
          </div>
          {p.story && <p className="font-manrope text-lg text-dark/70 leading-relaxed mt-6 max-w-3xl">{p.story}</p>}
          {p.practices && (
            <div className="mt-6 flex flex-wrap gap-2">
              {p.practices.split(',').map((x, i) => <span key={i} className="badge-organic"><Leaf className="w-3 h-3 inline mr-1" />{x.trim()}</span>)}
            </div>
          )}

          {data.products.length > 0 && (
            <div className="mt-10">
              <h2 className="font-playfair text-2xl font-bold text-dark mb-6">Products from this farm</h2>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {data.products.map((pr, i) => (
                  <div key={i} className="bg-cream rounded-2xl overflow-hidden border border-forest/10">
                    <div className="h-40 overflow-hidden bg-forest/5">
                      <img src={fileUrl(pr.image_file_id) || 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=600'} alt={pr.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="p-4">
                      <span className="badge-local text-[10px]">{pr.category}</span>
                      <h3 className="font-playfair text-lg font-bold text-dark mt-2">{pr.name}</h3>
                      {pr.description && <p className="font-manrope text-sm text-dark/60 mt-1 line-clamp-2">{pr.description}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
